<template>
  <!-- Default form register -->
  <form>
    <div class="container">
      <br />
      <p class="h4 text-center mb-4">{{ titel }}</p>
    </div>
    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text">Nombre</span>
      </div>
      <input
        aria-label="First name"
        id="name"
        class="form-control"
        v-model="task.name"
      />
    </div>

    <br />

    <div class="col-auto">
      <div class="form-check mb-2">
        <input
          class="form-check-input"
          type="checkbox"
          id="checkboxForm"
          v-model="task.is_menu"
        />
        <label class="form-check-label" for="autoSizingCheck">Es menu</label>
      </div>
    </div>

    <br />
    <div>
      <label for="tags-basic"
        >Escriba una nueva subcategoría y presiona enter</label
      >
      <b-form-tags
        input-id="tags-basic"
        v-model="getList"
        class="mb-2"
      ></b-form-tags>
    </div>
    <!--:formatter="formatter"-->
    <!--div>
      <vue-tags-input v-model="getList" :tags="values" @tags-changed="newTags => values = newTags" />
    </div-->
    <br />

    <div
      class="btn-group"
      role="group"
      aria-label="Basic example"
      v-show="this.update"
    >
      <button type="button" class="btn btn-warning" @click="editar(task)">
        Guardar
      </button>
      <button
        type="button"
        class="btn btn-danger"
        @click="eliminar(task.category_id)"
      >
        Borrar
      </button>
      <button type="button" class="btn btn-success" @click="nuevo">
        Nuevo
      </button>
    </div>

    <div class v-show="!this.update">
      <button
        type="button"
        class="btn btn-success btn-lg btn-block"
        @click="agregar"
      >
        Agregar
      </button>
    </div>
  </form>
</template>

<script>
import {
  createNewCategory,
  editCategory,
  deleteCategory,
} from "./../../api/conection";
import VueTagsInput from "@johmun/vue-tags-input";

export default {
  components: {
    VueTagsInput,
  },
  name: "taskForm",
  props: {
    task: {
      type: Object,
      default: {},
    },
    values: {
      type: Array,
      default: [],
    },
    update: false,
  },
  data() {
    return {
      titel: "Formulario de Categoría",
      value: "",
      tags: [],
    };
  },
  computed: {
    getList: {
      // getter
      get: function() {
        return this.values;
      },
      // setter

      set: function(setValues) {
        this.values = setValues;
      },
    },
  },
  methods: {
    agregar() {
      let { name, is_menu } = this.task;
      const subCategories = this.values;
      const body = { name, is_menu, subCategories };
      console.log(subCategories);
      //console.log(this.values);

      createNewCategory(body)
        .then((response) => {
          if (response.status === 201) {
            body.category_id = response.body.category_id;
            this.$store.dispatch("addTaskAction", body);
          }
          /** reseteo form */
          this.nuevo();
        })
        .catch((err) => {
          /** reseteo form */
          this.nuevo();
          console.log(err);
        });
    },
    editar(ctg) {
      //debugger;
      const id = ctg.category_id;

      ctg.sub_categories = this.values;
      editCategory(ctg, id)
        .then((response) => {
          console.log(response);
          if (response.status === 200) {
            ctg.subcategories = response.body.subcategories;
            this.$store.dispatch("updateTaskAction", ctg);
          }
          /** reseteo form */
          this.nuevo();
          //console.log(response);
        })
        .catch((err) => {
          /** reseteo form */
          this.nuevo();
          console.log(err);
        });
    },
    eliminar(ctg_id) {
      if (confirm("Está seguro que quiere borrar Esta categoría?")) {
        deleteCategory(ctg_id)
          .then((result) => {
            if (result.status === 200) {
              this.$store.dispatch("deleteTaskAction", ctg_id);
              /** reseteo form */
              this.nuevo();
            }
          })
          .catch((err) => {
            /** reseteo form */
            this.nuevo();
            console.log(err);
          });
      }
    },
    nuevo() {
      this.$store.dispatch("unSelectTaskAction", {});
    },
  },
};
</script>

<style>
.input-group-text {
  min-width: 100px;
}
form {
  padding: 15px;
}
</style>
